module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921054151_T.6af356cb.jpg";